define('lib/ajax-failure-handler/ajax-failure-handler',['require','exports','module','lodash','durandal/app','lib/auth/auth','i18next','web-urls'],function (require, exports, module) {
    var _ = require('lodash');
    var app = require('durandal/app');
    var auth = require('lib/auth/auth');
    var i18n = require('i18next');
    var webUrls = require('web-urls');

    /*
     * Handles error occuring from AJAX requests like: 401, 403 and 5xx.
     *
     * @param jqXHR - jQuery XHR object, first parameter of failed call
     * @param operation - RESTful Verb used (i.e. GET, POST etc)
     * @param url - URL for the ajax request
     */

    var handleAjaxFailure = function (jqXHR, operation, url) {
        var httpStatus = jqXHR.status;
        var resource = _.last(url.split('/')).split('?')[0];
        var watchedResources = ['user', 'meeting', 'meetings', 'settings', 'numbers'];
        var banner;
        var isValidError = httpStatus || httpStatus === 0;

        if (httpStatus === 401) {
            auth.retrieveFreshToken();
        } else if (httpStatus === 403) {
            window.location.replace(webUrls.get('myaccountUrl'));
        } else if (isValidError) {
            if (_.contains(watchedResources, resource)) {
                if (httpStatus.toString()[0] === '4') {
                    banner = {
                        classes: 'alert-warning',
                        message: i18n.t('unknown.error'),
                        iconClasses: 'togo-icon togo-icon-alert'
                    };
                    app.trigger('banner:addOne', banner);
                } else if (httpStatus === 0 || httpStatus.toString()[0] === '5') {
                    banner = {
                        classes: 'alert-danger',
                        message: i18n.t('unknown.error'),
                        iconClasses: 'togo-icon togo-icon-alert'
                    };
                    app.trigger('banner:addOne', banner);
                }
            }
        }
    };

    module.exports = handleAjaxFailure;
});

